module.exports = __webpack_public_path__ + "static/pexels-megapixelstock-17834_new-f4010a22a285aa9758be8644b7cd768c.jpg";